import { Card, CardContent } from '@/components/ui/card';
import { Users, FileEdit, Send, CheckCircle2 } from 'lucide-react';

// Compact portfolio summary — complements "My Next Actions" strip rather than
// duplicating it. Focuses on totals, not on actionable piles.
const CARDS = [
  { key: 'total_assigned', label: 'Total Assigned', icon: Users, testid: 'kpi-agent-total-assigned' },
  { key: 'drafts_in_progress', label: 'In Progress', icon: FileEdit, testid: 'kpi-agent-drafts' },
  { key: 'ready_to_submit', label: 'Submission Ready', icon: CheckCircle2, testid: 'kpi-agent-ready' },
  { key: 'submitted_count', label: 'Submitted', icon: Send, testid: 'kpi-agent-submitted' },
];

const AgentKpiStrip = ({ data, loading }) => (
  <div className="mb-5" data-testid="agent-kpi-strip">
    <div className="text-[10px] uppercase tracking-wide font-semibold text-gray-500 mb-2">Portfolio Summary</div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {CARDS.map(c => {
        const Icon = c.icon;
        const value = data?.[c.key] ?? 0;
        return (
          <Card key={c.key} data-testid={c.testid} className={`border border-gray-200 bg-slate-50/60 ${loading && !data ? 'animate-pulse' : ''}`}>
            <CardContent className="py-2.5 px-3 flex items-center justify-between">
              <div>
                <div className="text-[9px] uppercase tracking-wide text-gray-500 leading-tight">{c.label}</div>
                <div className="text-lg font-bold font-mono tabular-nums text-slate-800 leading-tight">{value}</div>
              </div>
              <Icon className="h-3.5 w-3.5 text-slate-400" />
            </CardContent>
          </Card>
        );
      })}
    </div>
  </div>
);

export default AgentKpiStrip;
